import { useCallback, useEffect } from "react";
import { debounce } from "lodash";

export const useLetterAutoSave = ({ enabled, form, onSave }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- debounce fn deps intentionally minimal
  const debouncedSave = useCallback(
    debounce((values) => onSave(values), 1000),
    [onSave]
  );

  useEffect(() => {
    if (!enabled) return;
    const subscription = form.watch((values) => debouncedSave(values));
    return () => subscription.unsubscribe();
  }, [enabled, form, debouncedSave]);
};
